var appConfig = {};

if (process.env.NODE_ENV === 'production') {
  appConfig.serverUrl = `${window.location.protocol}//${window.location.host}/`;
} else {
  appConfig.serverUrl = 'http://localhost:5000/';
}

appConfig.apiUrl = appConfig.serverUrl + 'api/1/';
appConfig.loginServiceUrl = 'https://login.softwarepark.cc/'

export default appConfig;



// WEBPACK FOOTER //
// ./src/config/appConfig.js